<div class="basket-list-container">
  <div class="content">
    <div class="list-head">
      <span class="first">{{ 'basket.header.article' | translate }}</span>
      <div class="middle">
        <span class="second">{{ 'basket.header.unitPrice' | translate }}</span>
        <span class="third">{{ 'basket.header.count' | translate }}</span>
      </div>
      <span class="fourth">{{ 'basket.header.totalPrice' | translate }}</span>
    </div>
    <div *ngIf="isMultiVendor">
      <div *ngIf="!networkPartner; else withNetworkPartner ">
        <div class="partner-header">
          <div *ngIf="!networkPartner">{{ 'basket.list.partner.header.later' | translate }}</div>
        </div>
      </div>
      <ng-template #withNetworkPartner>
        <div (click)="showNetworkPartnerDialog()" class="partner-header cursor">
          <span>{{ 'basket.list.partner.header' | translate }}
            <span class="partner-name">{{networkPartner.registeredName | uppercase}}</span>
          </span>
        </div>
      </ng-template>
    </div>
    <kion-basket-list-item
      (delete)="delete($event)"
      (quantityChanged)="quantityChanged($event)"
      *ngFor="let entry of entries"
      [editable]="editable"
      [entry]="entry"
    ></kion-basket-list-item>
  </div>
</div>
